/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.actor.declaration'

export { $nsid }

/** A declaration of a Bluesky chat account. */
type Main = {
  $type: 'chat.bsky.actor.declaration'
  allowIncoming: 'all' | 'none' | 'following' | l.UnknownString

  /**
   * Declaration about group chat invitation preferences for the record owner.
   */
  allowGroupInvites?: 'all' | 'none' | 'following' | l.UnknownString
}

export type { Main }

/** A declaration of a Bluesky chat account. */
const main = /*#__PURE__*/ l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  /*#__PURE__*/ l.object({
    allowIncoming: /*#__PURE__*/ l.string<{
      knownValues: ['all', 'none', 'following']
    }>(),
    allowGroupInvites: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['all', 'none', 'following'] }>(),
    ),
  }),
)

export { main }

export const $type = $nsid
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
